import CartesiRollups from "../../../common/technologies/cartesi-rollups";
import Docker from "../../../common/technologies/docker";
import Python from "../../../common/technologies/python3";
import Sqlite from "../../../common/technologies/sqlite";

function Cartesi() {
  return (
    <div className={'portfolio-modal'}>
      <h1>Cartesi</h1>
      <h4>Overview</h4>
      <p>
        Cartesi Rollups is a flatform supports non-blockchain dev can develop a decentrialize application without learning to build smartcontract.
        The purpose of project is to try and get used to the platform by building a voting dapp. A voting dapp allows users vote other's campaign and create their own campaign.
      </p>
      <h4>The difficult parts</h4>
      <ul>
        <li>Understand the concept of the platform</li>
      </ul>
      <h4>My roles and responsibilities</h4>
      <ul>
        <li>Responsible for entire backend logic.</li>
      </ul>
      <h4>Technologies used</h4>
      <div className={'project-technologies'}>
        <Python />
        <Sqlite />
        <CartesiRollups />
        <Docker />
      </div>
      <h4>What I learnt from this project</h4>
      <ul>
        <li>Get used to with blockchain</li>
        <li>Successfully build a dapp</li>
      </ul>
    </div>
  )
}

export default Cartesi;
